/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import QrReader from 'react-qr-scanner';
import { API_BASE } from '../config';
import '../styles/QrScannerComponent.css';

const QrScannerComponent = () => {
  const { token, userRole } = useAuth();
  const { po_number } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const orderData = location.state?.orderData;
  const [lastScannedCode, setLastScannedCode] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const scannerMessage = userRole === 'frozen' ? 'Escanea un frío' : 'Escanea un abarrote';

  const resetScannerState = () => {
    setLastScannedCode(null);
    setIsProcessing(false);
  };

  const handleScan = async (data) => {
    if (!data || data.text === lastScannedCode || isProcessing) return;

    const normalizedResult = data.text.trim();
    setLastScannedCode(normalizedResult);
    setIsProcessing(true);

    if (
      (userRole === 'picker' && normalizedResult.startsWith('CART')) ||
      (userRole === 'frozen' && normalizedResult.startsWith('BASKET'))
    ) {
      try {
        const response = await fetch(`${API_BASE}/assign-cart/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`,
          },
          body: JSON.stringify({
            po_number: po_number,
            cart_code: normalizedResult,
            shopping_cart: userRole === 'picker',
          }),
        });

        if (response.ok) {
          const successMessage =
            userRole === 'picker' ? 'Abarrote asignado exitosamente.' : 'Frío asignado exitosamente.';
          alert(successMessage);
          navigate(`/picker/${po_number}/${normalizedResult}`, {
            state: { orderData: orderData }
          });
        } else {
          let message = 'Error al asignar el carrito. Por favor, intente nuevamente.';
          try {
            const errorBody = await response.json();
            if (errorBody && errorBody.error) message = errorBody.error;
          } catch (parseErr) {
            // Not JSON: keep the generic message.
          }
          alert(message);
          resetScannerState();
        }
      } catch (error) {
        console.error('Error:', error);
        alert('Error de conexión. Por favor, intente nuevamente.');
        resetScannerState();
      }
    } else {
      alert('Código QR inválido. Por favor, escanee un código válido.');
      resetScannerState();
    }
  };

  const handleError = (err) => {
    console.error('Error al escanear el código QR:', err);
    alert('Ocurrió un error al intentar escanear. Verifica que la cámara esté disponible.');
    resetScannerState();
  };

  return (
    <div className="qrscanner-container">
      <button onClick={() => navigate('/picking')} className="qrscanner-back-button">
        &#8592;
      </button>

      <h1 className="qrscanner-title">{scannerMessage}</h1>

      <div className="qrscanner-video-container">
        <QrReader
          delay={300}
          onError={handleError}
          onScan={handleScan}
          style={{ width: '100%' }}
          constraints={{
            video: {
              facingMode: 'environment', // Force back camera
            },
          }}
        />
      </div>

      <p className="qrscanner-po-number">Número de PO: {po_number}</p>
    </div>
  );
};

export default QrScannerComponent;
